var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScannerOverlayDocFrontNoMrz = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 54,
    viewBox: "0 0 80 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.333496,
    width: 80,
    height: 53.3333,
    rx: 4,
    fill: "#8A8A8A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 38.875V36.7917C29.1667 35.6866 28.7277 34.6268 27.9463 33.8454C27.1649 33.064 26.1051 32.625 25 32.625H16.6667C15.5616 32.625 14.5018 33.064 13.7204 33.8454C12.939 34.6268 12.5 35.6866 12.5 36.7917V38.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8327 28.4583C23.1339 28.4583 24.9993 26.5929 24.9993 24.2917C24.9993 21.9905 23.1339 20.125 20.8327 20.125C18.5315 20.125 16.666 21.9905 16.666 24.2917C16.666 26.5929 18.5315 28.4583 20.8327 28.4583Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 38.6665H66.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30.3335H66.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22H66.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 13.6665H66.666",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScannerOverlayDocFrontNoMrz);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scanner-overlay-doc-front-no-mrz.97696a630552d6b6980aa43e488e5bc9.svg";